import { useEffect } from 'react';

import useBoolean from '../useBoolean/index.ts';

interface Handlers {
  onMouseDown: () => void;
  onMouseUp: () => void;
  onMouseLeave: () => void;
  onTouchStart: () => void;
  onTouchEnd: () => void;
  isHolding: boolean;
}
export default function useHoldPress(
  whileHolding: () => void = () => undefined,
  active = true
): Handlers {
  const { value: isHolding, setTrue: beginHold, setFalse: endHold } = useBoolean(false);

  useEffect(() => {
    let timerId: number | null = null;
    let didUnMount = false;

    function frame() {
      if (didUnMount) {
        if (timerId) {
          cancelAnimationFrame(timerId);
        }

        return;
      }

      whileHolding();
      timerId = requestAnimationFrame(frame);
    }

    if (isHolding && !timerId) {
      timerId = requestAnimationFrame(frame);
    } else if (timerId) {
      cancelAnimationFrame(timerId);
      timerId = null;
    }

    return () => {
      didUnMount = true;

      if (timerId) {
        cancelAnimationFrame(timerId);
        timerId = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHolding]);
  useEffect(() => {
    if (!active) {
      endHold();
    }
  }, [active, endHold]);

  return {
    onMouseDown: beginHold,
    onMouseUp: endHold,
    onMouseLeave: endHold,
    onTouchStart: beginHold,
    onTouchEnd: endHold,
    isHolding
  };
}
